(function($) {
    $(function() {
        $('#contact-form').submit(function(e) {
            e.preventDefault();

            var hasErrors = false;
            var contactForm = $(this);
            var formdata = contactForm.serialize();

            // Check if any of the fields are empty
            // Add error class if no value is found
            var enquiryFieldValue = $('#enquiry').val();
            if (enquiryFieldValue == 'Select your type of enquiry') {
                $('#enquiry').addClass('has-error');

                hasErrors = true;
            } else {
                $('#enquiry').removeClass('has-error');
            }

            var fields = ['gitname', 'gitphone', 'gitemail', 'gitmessage', 'gitcompany'];
            var field_count = fields.length;
            var valid_fields = 0;
            $.each(fields, function(i, value) {
                if ($('#' + value).val() == '') {
                    $('#' + value).addClass('has-error');

                    hasErrors = true;
                } else {
                    // Validate the phone number
                    if ('gitphone' === value) {
                        if (! drpCheckValidPhoneNumber($('#' + value).val())) {
                            $('#' + value).addClass('has-error');

                            hasErrors = true;

                            // Continue..
                            return;
                        }
                    }

                    valid_fields++;

                    $('#' + value).removeClass('has-error');
                }
            });

            if (field_count == valid_fields) {
                $('.alert-danger.contact-form-incomplete').addClass('hide');
            }

            if ($('.g-recaptcha-response').val() == '') {
                hasErrors = true;

                $('.alert-danger.contact-form-captcha').removeClass('hide');
            } else {
                $('.alert-danger.contact-form-captcha').addClass('hide');
            }

            // If errors are found, show the error notification
            if (hasErrors) {
                $('.alert-danger.contact-form-incomplete').removeClass('hide');

                return false;
            }

            // If we get this far the form has been filled in correctly and we can proceed with sending the data
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: contactFormAjax.ajaxurl,
                data: {
                    action: 'contactformsubmit',
                    formdata: formdata,
                    security: contactFormAjax.security,
                },
                success: function(data) {
                    if (data.error == false) {
                        // Log the event
                        var analyticsData = {
                            'name': $('#gitname').val(),
                            'phone': $('#gitphone').val(),
                            'email': $('#gitemail').val(),
                            'company': $('#gitcompany').val(),
                            'message': $('#gitmessage').val(),
                            'enquiry': $('#enquiry').find(':selected').text(),
                            'gitproducttype': $('#gitproducttype').find(':selected').text(),
                            'gitservicingtype': $('#gitservicingtype').find(':selected').text(),
                            'other': $('#other').val(),
                            'contactoption': $('input[name="contact-option"]:checked').val(),
                            'current_page': $('#current_page').val()
                        };
                        analyticsTracking('getInTouchFormSubmit', analyticsData);

                        // Send an event to Google Analytics
                        if (typeof ga === 'function' || typeof window.ga !== 'undefined') {
                            ga('send', 'event', 'Submit get in touch form', 'click', 'Get in touch form');
                        }
                        // Hide all error notifications
                        $('.alert-danger').addClass('hide');

                        // Remove all error classes from the form
                        $('select, input, textarea, checkbox, radio', contactForm).each(function() {
                            $(this).removeClass('has-error');
                            // And the checkbox
                            $(this).parent().removeClass('has-error');

                            hasErrors = false;
                        });

                        // Show the success notification
                        $('.alert-success').removeClass('hide');

                        // Reset the form fields
                        contactForm.trigger('reset');

                        // Reset the captcha
                        grecaptcha.reset();
                    } else {
                        // Show the error notification
                        $('.alert-danger.contact-form-submission-failed').removeClass('hide');
                        if (data.captcha) {
                            // Reset the captcha
                            grecaptcha.reset();

                            $('.alert-danger.contact-form-captcha').removeClass('hide');
                        }
                    }
                }
            });
        });

        // Dynamically show/hide the extra select elements
        $('#enquiry').change(function(e) {
            var enquiryFieldValue = $(this).val();
            if (enquiryFieldValue == 'Select your type of enquiry') {
                $('#enquiry').addClass('has-error');

                hasErrors = true;
            } else {
                $('#enquiry').removeClass('has-error');
            }

            if (enquiryFieldValue === 'Installations') {
                $('#gitproducttype, .gitproducttype-intro').removeClass('hide');
            } else {
                $('#gitproducttype, .gitproducttype-intro').addClass('hide');
                $('#other').addClass('hide');
            }

            if (enquiryFieldValue === 'Servicing') {
                $('#gitservicingtype, .gitservicingtype-intro').removeClass('hide');
            } else {
                $('#gitservicingtype, .gitservicingtype-intro').addClass('hide');
                $('#other').addClass('hide');
            }
        });

        // Dynamically show/hide the "Other" free text input
        $('#gitproducttype, #gitservicingtype').change(function(e) {
            if ($(this).val() === 'Other') {
                $('#other').removeClass('hide');
            } else {
                $('#other').addClass('hide');
            }
        });
    });
})(jQuery);

/**
 * Check a phone number is valid.
 *
 * UK mobile number is 11 numbers - it may have a space.
 * UK land line number is 11 numbers - it may have a space.
 *
 * @since 1.0.0
 *
 * @param integer|string inputNumber
 * @return boolean
 */
function drpCheckValidPhoneNumber(inputNumber) {
    var phoneNumberRegexPattern = /^[0-9\+\s-]{8,13}$/;

    return inputNumber.match(phoneNumberRegexPattern) ? true : false;
}
